{
  "add": "Añadir",
  "create": "Crear",
  "confirm": "Confirmar",
  "creating": "Creando ...",
  "proceed": "Continuar",
  "update": "Actualizar",
  "edit": "Editar",
  "cancel": "Cancelar",
  "delete": "Eliminar",
  "process": "Proceso",
  "save": "Guardar",
  "later": "Más tarde",
  "next": "Siguiente",
  "continue": "Continuar",
  "activate": "Activar",
  "deactivate": "Desactivar",
  "error": "Error",
  "search": "Buscar",
  "download": "Descargar",
  "warning": "Advertencia",
  "notRequired": "No es necesario",
  "notEditable": "No editable",
  "goalValue": "de {{goalValue}}",
  "overfundedBy": "Sobrefinanciado en un {{percentage}} %",
  "sign": "Firme",
  "upload": "Cargar",
  "reupload": "Volver a cargar",
  "retry": "Volver a intentar",
  "import": "Importar",
  "validationError": {
    "unique": "Este registro ya existe. Por favor, seleccione otro",
    "sessionTimeout": "Su sesión ha caducado. Vuelva a iniciar sesión.",
    "tokenRefreshFailed": "Su sesión ha caducado. Vuelva a iniciar sesión.",
    "duplicateRecord": "Ya existe un registro con estos valores. Por favor, utilice valores únicos."
  },
  "backendIssuedError": {
    "organizationUserNotFound": "Configuración en curso o perfil no registrado. Inténtelo de nuevo más tarde."
  },
  "enable": "Habilitar",
  "enabled": "Habilitado",
  "disable": "Deshabilitar",
  "disabled": "Deshabilitado",
  "inheritedFlag": "Heredado",
  "inheritedTooltip": "Este {{model}} ha sido heredado de la organización {{organization}}. Póngase en contacto con la organización {{organization}} para cambiarlo.",
  "yes": "Sí",
  "no": "No",
  "inherited": "Heredado",
  "any": "Cualquiera",
  "true": "Verdadero",
  "false": "Falso",
  "requiedField": "¡Campo requerido!",
  "required": "Requerido",
  "requireAffiliate": "Tipo de cuenta: {{accountType}} requiere al menos un {{affiliateType}}",
  "noPermission": "No tiene permiso para acceder a este espacio",
  "missingPermissionIs": "el permiso que falta es",
  "back": "Atrás",
  "yesExit": "Sí, salir",
  "wizardInterruptionMsg": "Al cerrar esta ventana se borrarán sus progresos. ¿Está seguro de que desea salir?",
  "wizardTitle": "¿Salir de '{{wizardTitle}}'?",
  "somethingBelongingToSomeone": "{{what}} de {{whose}}",
  "household": "hogar",
  "powerOfAttorney": "Poder notarial",
  "okGotIt": "Vale, entendido",
  "copyToClientNotes": "Copiar a las notas del cliente",
  "organization": "Organización",
  "inheritedDashWhat": "Heredado - {{what}}",
  "someErrorHasOccurred": "¡Se ha producido un error!",
  "completed": "Completado",
  "relationship": "Relación",
  "phoneNumber": "Número de teléfono",
  "email": "Correo electrónico",
  "status": "Estado",
  "state": "Estado",
  "entity": "Entidad",
  "markAllAsRead": "Marcar todos como leídos",
  "noNotifications": "No tiene notificaciones",
  "notificationsMenu": {
    "title": "Notificaciones",
    "ALL": "Todas las actividades",
    "UNREAD": "No leído",
    "today": "Hoy"
  },
  "done": "Hecho",
  "clearAll": "Borrar todo",
  "addNewColumn": "Añadir nueva columna",
  "commaSeparated": "Separado por comas",
  "securityDetails": "Detalles de seguridad",
  "name": "Nombre",
  "type": "Tipo",
  "cash": "Efectivo",
  "actions": "Acciones",
  "archive": "Archivar",
  "only": "solo",
  "notClassified": "No clasificado",
  "publish": "Publicar",
  "unpublish": "No publicar",
  "viewAll": "Ver todo",
  "published": "Publicado",
  "inactive": "Inactivo",
  "saved": "Guardado",
  "successfullySaved": "Guardado correctamente",
  "filter": "Filtro",
  "perPage": "por página",
  "perPageWithSize": "{{size}} por página",
  "copiedToClipboard": "Copiado al portapapeles",
  "country": "País",
  "fixedColumn": "Columna fija",
  "tableDefinition": "Las tablas se pueden configurar para mostrar varios puntos de datos. En pantallas más pequeñas, la primera columna permanece fija, lo que permite desplazarse horizontalmente para ver las demás. La versión móvil simplificada solo muestra la información esencial, pero permite acceder al conjunto de datos completo al tocar la fila.",
  "browserTable": "Tabla del navegador",
  "mobileTable": "Tabla de móvil",
  "on": "en",
  "print": "Imprimir",
  "continued": "continuación",
  "auditLog": "Registro de auditoría",
  "start": "Iniciar",
  "end": "Finalizar",
  "objectId": "ID de objeto",
  "invalidObjectId": "ID de objeto no válido",
  "validObjectId": "ID de objeto válido",
  "loading": "Cargando ...",
  "copyID": "Copiar ID",
  "description": "Descripción",
  "inactiveModal": {
    "headingText": "¿Sigue ahí?",
    "prefixButton": "Mantenerme conectado",
    "suffixButton": "Cerrar sesión ahora",
    "bodyText1": "Debido a la inactividad, su sesión caducará en",
    "bodyText2": "segundos."
  },
  "SessionTimeoutLayoutModal": {
    "loginButton": "Iniciar sesión",
    "headingText": "Se ha cerrado su sesión",
    "bodyText": "Debido a la inactividad, su sesión ha caducado. Si desea seguir utilizando la aplicación, vuelva a iniciar sesión."
  },
  "withdraw": "Retirar",
  "deposit": "Depositar",
  "amountUnavailable": " Importe no disponible",
  "errorStateSubText": "Hay un problema con el sistema. Inténtelo de nuevo más tarde.",
  "errroStateTitle": "No se pueden cargar los datos",
  "errroStateAccountTitle": "No se pueden cargar las cuentas",
  "errroStateGoalTitle": "No se pueden cargar las metas",
  "paginationSummary": "{{start}}-{{end}} de {{total}}",
  "genderOptions": {
    "MALE": "Hombre",
    "FEMALE": "Mujer",
    "OTHER": "Otro sexo"
  },
  "invalidAllocations": "La asignación total para cada tipo de afiliación debe ser exactamente del 100 %.",
  "maxAttemptsExceeded": "Ha alcanzado el número máximo de intentos. Póngase en contacto con el servicio de asistencia.",
  "failedVerificationAttemp": "Algunas respuestas de verificación son incorrectas. Le quedan {{attempt}} intento(s)",
  "profileDetailsUpdated": "Se han actualizado los datos del perfil.",
  "objectUpdated": "{{object}} actualizado correctamente.",
  "objectClosed": "{{object}} ha sido cerrado.",
  "objectArchived": "{{object}} ha sido archivado.",
  "unsafeUrl": "URL no válida o insegura. El enlace no se pudo abrir por motivos de seguridad.",
  "draft": "Borrador",
  "nameRequired": "Nombre requerido",
  "submit": "Enviar",
  "dataTablePaginationSummary": "Filas: {{start}}–{{end}} de {{total}}",
  "rowsPerPage": "Filas por página:",
  "close": "Cerrar",
  "unknownOrganization": "Desconocido",
  "relationshipInformation": {
    "selectSpouse": "Seleccionar cónyuge",
    "selectTrustedContact": "Seleccionar persona de contacto de confianza",
    "clearSelectedSpouse": "Borrar cónyuge seleccionado",
    "clearSelectedTrustedContact": "Borrar PCT seleccionado",
    "relationUpdateError": "Algo salió mal al actualizar la relación. Por favor, inténtelo de nuevo."
  },
  "saveForLater": "Guardar para más tarde",
  "somethingWentWrong": "Algo salió mal",
  "home": "Inicio",
  "unknownRole": "Rol desconocido",
  "organizationSwitchNotSaved": "Su cambio no se guardó. Es posible que no tenga permiso para cambiar esta configuración."
}
